interface AuthorImageProps {
  alt: string;
  size?: number;
  src?: string | null;
  placeholder?: 'eklipX';
}

function AuthorImage({ alt, size = 10, src, placeholder }: AuthorImageProps) {
  const placeholderSrc =
    placeholder === 'eklipX' ? '/eklipx-profile-image-placeholder.png' : '/default-profile-image-placeholder.png';

  return (
    <div className={`drop-shadow-md border rounded-full overflow-hidden min-w-10 h-${size} w-${size}`}>
      <img src={src || placeholderSrc} alt={alt} className='w-full h-full object-cover' />
    </div>
  );
}

export default AuthorImage;
